import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Breadcrumb, Divider, Grid } from 'antd';
import Pict from '../../assets/img/group.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function About() {
  let { xs, lg } = useBreakpoint()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>About</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xs={24} md={12} style={{ paddingBottom: 16 }}>
          <Image
            width={'100%'}
            src={Pict}
            preview={false}
            style={{ objectFit: 'cover' }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Aims and Scope</Text>
            <Text style={{ fontSize: 15 }}>The 2nd World Conference on Health and Social Sciences (WCHSS) is an international gathering hosted by Universitas Binawan. Building upon the success of our inaugural conference, WCHSS aims to foster interdisciplinary dialogue and innovation in the realms of health and social sciences.</Text>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Vision</Text>
            <Text style={{ fontSize: 15 }}>We envision WCHSS as a catalyst for positive change, driving advancements in healthcare delivery, social policy, and community well-being. By bridging the gap between theory and practice, we aim to empower individuals and organizations to make informed decisions and implement evidence-based strategies for a healthier, more equitable society.</Text>
          </Space>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 8 : 16}>
            <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Mission</Text>
            <Text style={{ fontSize: 15 }}>At WCHSS, our mission is to facilitate meaningful connections and knowledge exchange among researchers, practitioners, policymakers, and industry leaders. Through our diverse program of keynote speeches, panel discussions, and networking sessions, we strive to address pressing global challenges and explore transformative solutions.</Text>
          </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Row style={{ textAlign: 'center' }}>
            <Col span={24}>
              <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Organizer</Text>
            </Col>
          </Row>
          <Row gutter={[0,16]} style={{ marginTop: 64 }}>
            <Col span={24}>
              <Text style={{ fontSize: 15 }}>Universitas Binawan is proud to serve as the host institution for WCHSS. Established with a commitment to academic excellence and societal impact, Universitas Binawan is dedicated to advancing knowledge, nurturing talent, and addressing the complex challenges facing our world today.</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>International Advisors</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Prof. Vidhya Venugopal (Sri Ramachandra Institute of Higher Education and Research)</Text>
                  <Text style={{ fontSize: 16 }}>Dr. M. Arsyad Subu (University of Sharjah)</Text>
                  <Text style={{ fontSize: 16 }}>Cynthia Febrina Maharani, SKM, M.Sc (University of Sharjah)</Text>
                  <Text style={{ fontSize: 16 }}>Prof. Erwin Faller (Holy Child Center College Inc.)</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Coordinator</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Anna Suraya, MKK, SpOk (K), Ph.D.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Vice Coordinator</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Maryuni, Amd. Keb, SKM, MKM</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Treasurer</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dinni Randayani Lubis, SST, M.Kes</Text>
                  <Text style={{ fontSize: 16 }}>Tri Rahayu, SE.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Public Relation and Sponsorship </Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Uci Sulandari, S.Si, M.Si.</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Ikhwan HS, SE, MM., M.Si</Text>
                  <Text style={{ fontSize: 16 }}>Etyca Rizky Yanti, S.E., M.M.</Text>
                  <Text style={{ fontSize: 16 }}>Ns. Apriana Rahmawati, S.Kep., M.Kep</Text>
                  <Text style={{ fontSize: 16 }}>Rasyid Avicena S.Gz., M.Gz.</Text>
                  <Text style={{ fontSize: 16 }}>Ftr. Yulis Susanti, S.FT, M.KM</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Administration and Registration</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Septiani S.Pt, M.Pkim</Text>
                  <Text style={{ fontSize: 16 }}>Hanif Aulawi, SE., MM</Text>
                  <Text style={{ fontSize: 16 }}>Dian Rachma Wijayanti, M.Sc.</Text>
                  <Text style={{ fontSize: 16 }}>Putri Winda Lestari, S.KM., M.Kes.</Text>
                  <Text style={{ fontSize: 16 }}>Rita Casmita, S.Pd.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Speaker</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Lutfi Handayani, S.ST., M. Keb</Text>
                  <Text style={{ fontSize: 16 }}>Puji Astuti Wiratmo S.Kep, M.N</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Lelitasari, MKK</Text>
                  <Text style={{ fontSize: 16 }}>Ika Apriati, M.Psi., Psikolog</Text>
                  <Text style={{ fontSize: 16 }}>Dr. Renan Prasta Jenie, STP, M</Text>
                  <Text style={{ fontSize: 16 }}>Uut Hanafi Hanafi Rochman SSt, Sp.P.S.B.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Publication</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Dr. Renan Prasta Jenie, STP, M</Text>
                  <Text style={{ fontSize: 16 }}>Ns. Apriana Rahmawati, S.Kep., M.Kep</Text>
                  <Text style={{ fontSize: 16 }}>Legina Anggraeni S.ST., M.K.M.</Text>
                  <Text style={{ fontSize: 16 }}>Ns. Nurlelasari Harahap, S.Kep., M.Kep</Text>
                  <Text style={{ fontSize: 16 }}>Irwanti Gustina, SST,Mkes</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Event Organization</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Ns. Mochamad Robby Fajar Cahya, S.Kep., MSN.</Text>
                  <Text style={{ fontSize: 16 }}>Jimny Hilda Fauzia, M.Psi., Psikolog</Text>
                  <Text style={{ fontSize: 16 }}>Mari Esterilita, S. Tr. Sos,Sp.P. S.A.</Text>
                  <Text style={{ fontSize: 16 }}>Erika Lubis, S.Kp., MN</Text>
                  <Text style={{ fontSize: 16 }}>Ns. Agung Setiyadi,S.Kep., MM., MSN</Text>
                  <Text style={{ fontSize: 16 }}>Rio Nardo, SE., MM</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Consumption</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Tri Mustikowati, S.Kp., M.Kep.</Text>
                  <Text style={{ fontSize: 16 }}>Yunita Sari Purba, SST.K3., MA</Text>
                  <Text style={{ fontSize: 16 }}>Apt. Ernie Halimatushadyah, S.Farm., M.Farm.</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of Infrastructure</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Mella Yuria R.A.,SKM.,M.Kes</Text>
                  <Text style={{ fontSize: 16 }}>Ftr. Zulfikar H Wada, S.FT, M.Fis</Text>
                  <Text style={{ fontSize: 16 }}>Noval Said Alwynni S.Si., M.Sc.</Text>
                  <Text style={{ fontSize: 16 }}>Riffi Arifiansyah</Text>
                </Space>
              </Space>
            </Col>

            <Col xs={24} lg={12}>
              <Text style={{ fontSize: 18, fontWeight: 500 }}>Team of IT and Creative</Text>
            </Col>
            <Col xs={24} lg={12}>
              <Space align="start" size={16}>
                {
                  lg ?
                  <Text style={{ fontSize: 16 }}>:</Text>
                  : null
                }
                <Space direction="vertical" size={4}>
                  <Text style={{ fontSize: 16 }}>Gusti Arsyad, S.Kom., M.Cs.</Text>
                  <Text style={{ fontSize: 16 }}>Muhammad Arif Abdul Hakim S.S.I., M.M.S.I.</Text>
                  <Text style={{ fontSize: 16 }}>Martina Ingga</Text>
                </Space>
              </Space>
            </Col>

            <Col span={24} style={{ marginTop: 16 }}>
              <Text italic style={{ fontSize: 16 }}>Join us at WCHSS and be a part of this transformative journey towards a brighter future for health and social sciences.</Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default About